module.exports = __webpack_public_path__ + "static/media/earning_without_detail.9a586b6b.svg";